import type { SVGProps } from 'react';

export const ChevronDown = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="m12 12.95 4.075-4.075a.774.774 0 0 1 .5-.225c.217 0 .4.075.55.225a.72.72 0 0 1 .225.525.72.72 0 0 1-.225.525l-4.5 4.5a.681.681 0 0 1-.3.175.716.716 0 0 1-.325.075.882.882 0 0 1-.35-.075.701.701 0 0 1-.275-.175l-4.5-4.5A.801.801 0 0 1 6.65 9.4c0-.2.075-.375.225-.525A.72.72 0 0 1 7.4 8.65c.2 0 .375.075.525.225L12 12.95Z" />
    </svg>
  );
};
